import {
  PrimaryIconButton,
  PrimaryInverseIconButton,
  SecondaryIconButton,
  SecondaryInverseIconButton,
  TertiaryIconButton,
  TertiaryInverseIconButton,
} from './IconButton.styles';
import { IconButtonProps, IconButtonType, IconButtonVariant } from './IconButton.types';

export const IconButton = (props: IconButtonProps) => {
  const {
    priority = 'primary',
    variant = 'primary',
    size = 'large',
    hover = false,
    ...rest
  } = props;

  rest.className += hover ? ' hover' : '';

  const iconButtonProps = {
    ...rest,
    priority,
    variant,
    size,
  };

  const iconButtons: {
    [key in IconButtonType]: {
      [variant in IconButtonVariant]: () => JSX.Element;
    };
  } = {
    primary: {
      primary: () => <PrimaryIconButton {...iconButtonProps} />,
      inverse: () => <PrimaryInverseIconButton {...iconButtonProps} />,
    },
    secondary: {
      primary: () => <SecondaryIconButton {...iconButtonProps} />,
      inverse: () => <SecondaryInverseIconButton {...iconButtonProps} />,
    },
    tertiary: {
      primary: () => <TertiaryIconButton {...iconButtonProps} />,
      inverse: () => <TertiaryInverseIconButton {...iconButtonProps} />,
    },
  };

  const ibType = iconButtons[priority] ?? iconButtons.primary;
  const icVariant = ibType[variant] ?? ibType.primary;
  return icVariant();
};
